import { useTranslation } from 'react-i18next';
import useDataTestId from '~/hooks/useDataTestId';
import { Money } from '~/types/money';
import { formatSign, isMoneyGreaterThan } from '~/utils/money';
import { cleanValue, parseValueForInput } from '~/utils/numberInputs';
import AmountField from './inputs/TextField/AmountField';

const RemainingAmountTextField = ({
  onChange,
  dataTestId,
  value,
  limit,
  placeholder,
}: {
  value: Money;
  limit: Money;
  dataTestId?: string;
  placeholder?: string;
  onChange: (v: Money) => void;
}) => {
  const { t } = useTranslation('reconciliations');
  const dt = useDataTestId(dataTestId);

  const handleOnChange = (newValue: string) => {
    const amount = cleanValue(newValue).replace('-', '');
    const newAmount = { amount, currency: value.currency };

    if (isMoneyGreaterThan(newAmount, limit)) {
      onChange(limit);
    } else {
      onChange(newAmount);
    }
  };

  return (
    <AmountField
      data-testid={dt('reconciliationAmount')}
      value={parseValueForInput(value.amount)}
      onChange={handleOnChange}
      label={t('amount')}
      hideLabel
      maxDecimalPlaces={2}
      endAddon={formatSign(value.currency)}
      placeholder={placeholder}
    />
  );
};

export default RemainingAmountTextField;
